var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicalNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 32C32.3333 32 30.9167 31.4167 29.75 30.25C28.5833 29.0833 28 27.6667 28 26C28 24.3333 28.5833 22.9167 29.75 21.75C30.9167 20.5833 32.3333 20 34 20C35.6667 20 37.0833 20.5833 38.25 21.75C39.4167 22.9167 40 24.3333 40 26C40 27.6667 39.4167 29.0833 38.25 30.25C37.0833 31.4167 35.6667 32 34 32ZM22 46V40.2C22 39.5 22.1667 38.8417 22.5 38.225C22.8333 37.6083 23.3 37.1167 23.9 36.75C24.9667 36.1167 26.0917 35.5917 27.275 35.175C28.4583 34.7583 29.6667 34.45 30.9 34.25L34 38L37.1 34.25C38.3333 34.45 39.5333 34.7583 40.7 35.175C41.8667 35.5917 42.9833 36.1167 44.05 36.75C44.65 37.1167 45.125 37.6083 45.475 38.225C45.825 38.8417 46 39.5 46 40.2V46H22ZM18 40.2V42H10C8.9 42 7.95833 41.6083 7.175 40.825C6.39167 40.0417 6 39.1 6 38V10C6 8.9 6.39167 7.95833 7.175 7.175C7.95833 6.39167 8.9 6 10 6H38C39.1 6 40.0417 6.39167 40.825 7.175C41.6083 7.95833 42 8.9 42 10V20C40.9667 18.7 39.8 17.7083 38.5 17.025C37.2 16.3417 35.7 16 34 16V14H14V18H28C27.3333 18.5333 26.7333 19.1333 26.2 19.8C25.6667 20.4667 25.2167 21.2 24.85 22H14V26H24C24 26.7 24.075 27.3833 24.225 28.05C24.375 28.7167 24.5833 29.3667 24.85 30H14V34H20.9C20 34.7667 19.2917 35.6917 18.775 36.775C18.2583 37.8583 18 39 18 40.2Z",
    fill: "url(#paint0_linear_4247_943)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4247_943",
    x1: 9.91304,
    y1: 45.6666,
    x2: 38.183,
    y2: 27.1004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalNotes);
export default __webpack_public_path__ + "static/media/clinical_notes.271b087cdbe09900b4276cd69c64280b.svg";
export { ForwardRef as ReactComponent };